<template>
  <div slot="no-body">
    <div class="p-8 login-tabs-container">
      <div class="vx-card__title mb-4">
        <h4 class="mb-4">Inloggen voor bedrijven</h4>
      </div>
      <form @submit="login">
        <vs-input
          name="email"
          icon-no-border
          icon="icon icon-user"
          icon-pack="feather"
          label-placeholder="Email"
          v-model="email"
          class="w-full"
        />
        <vs-input
          type="password"
          name="password"
          icon-no-border
          icon="icon icon-lock"
          icon-pack="feather"
          label-placeholder="Password"
          v-model="password"
          class="w-full mt-6"
          v-on:keyup.enter="login"
        />
        <div class="flex flex-wrap justify-between my-5">
          <router-link to="/contact/resetpassword">Wachtwoord vergeten?</router-link>
        </div>
        <vs-button class="float-right" :disabled="!validateForm" @click="login">Inloggen</vs-button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ht-company-login",
  data() {
    return {
      email: "",
      password: "",
      checkbox_remember_me: false,
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email !== "" && this.password !== "";
    },
  },
  methods: {
    checkLogin() {
      // If user is already logged in notify
      if (localStorage.getItem("companytoken") !== null) {
        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: "Login Attempt",
          text: "You are already logged in!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });

        var company = JSON.parse(localStorage.getItem("user")).companies[0];

        this.$router.push({
          name: "companies-single-dashboard",
          params: { slug: company.slug },
        });

        return false;
      }
      return true;
    },
    login() {
      if (!this.checkLogin()) return;

      localStorage.removeItem("stafftoken");
      localStorage.removeItem("user");

      // Loading
      this.$vs.loading();

      const data = {
        email: this.email,
        password: this.password,
      };

      this.$http
        .post("https://companyapi.hebtrek.nl/v1/authenticate", data)
        .then((response) => {
          if (response.data.token) {
            this.stopLoading();

            localStorage.setItem(
              "companytoken",
              JSON.stringify(response.data.token)
            );
            localStorage.setItem("user", JSON.stringify(response.data.user));

            var company = response.data.user.companies[0];
            localStorage.setItem("company-selected", JSON.stringify(company));
            this.$router.push({
              name: "companies-dashboard",
              params: { slug: company.slug },
            });
            location.reload(true);
          }
        })
        .catch((error) => {
          this.stopLoading();
          this.notify(
            "",
            "Verkeerde gebruikersnaam/wachtwoord, probeer het alsjeblieft opnieuw!"
          );
        });
    },
    stopLoading() {
      this.$vs.loading.close();
    },
    notify(title, message) {
      this.$vs.notify({
        title: title,
        text: message,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
      });
    },
  },
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
